Wee.fn.make('swiper', {
	init: function() {
		var $swiper = $('.swiper-container');

		if ($swiper.length) {
			this.swiper = new Swiper($swiper[0], {
				pagination: '.swiper-pagination',
				paginationClickable: true,
				loop: true
			});
		}
	},

	unload: function() {
		if ($('.swiper-container').length) {
			this.swiper.destroy();
		}
	}
});
